import { IconName, List, ListItem, Text, TextLevels } from '@bytel/trilogy-react';

import { MobilePlanType } from '@app-types/plan';

type PlanNuggetsListProps = { plan: MobilePlanType };

export function PlanNuggetsList({ plan }: Readonly<PlanNuggetsListProps>) {
    return (
        <List>
            {plan.maxConnections === '5g' ? (
                <ListItem iconName={IconName.UI_5G}>
                    <Text level={TextLevels.TWO}>Forfait 5G</Text>
                </ListItem>
            ) : (
                <ListItem iconName={IconName.UI_4G}>
                    <Text level={TextLevels.TWO}>Forfait 4G</Text>
                </ListItem>
            )}
            {plan.detailsDescription && (
                <ListItem iconName={IconName.AIR_TRAVEL}>
                    <Text level={TextLevels.TWO}>
                        <span
                            dangerouslySetInnerHTML={{
                                __html: `${plan.dataEnvelope} ${plan.detailsDescription}`,
                            }}
                        />
                    </Text>
                </ListItem>
            )}
            {plan.smsMms && (
                <ListItem iconName={IconName.PHONE_INFINITY}>
                    <Text level={TextLevels.TWO}>Appels et SMS illimités</Text>
                </ListItem>
            )}
        </List>
    );
}
